export default __webpack_public_path__ + "static/media/New.98a9555e.jpg";